<template>
    <template v-if="!shouldStartTimer">
        <div class="inlineFlex align-items">
            <label
                class="bigAlert margin0"
                :class="{
                    darkGreen: ['not started', 'scheduled'].includes(testObj.status),
                }"
            >
                <span class="visible-hidden">Activity Status</span>
                <template v-if="['ended', 'completed'].includes(testObj.status)"> ACTIVITY ENDED </template>
                <template v-if="['not started', 'scheduled'].includes(testObj.status)">
                    <template v-if="testObj.status == 'not started'"> NOT STARTED </template>
                    <template v-else> SCHEDULED </template>
                </template>
            </label>

            <router-link
                v-if="showWindowLink && !isMobileView"
                v-tooltip="'Show in new window'"
                :to="{
                    name: 'activities.tests.timer',
                    params: { id: testObj.uuid },
                }"
                class="btn btn-default"
                target="_blank"
                aria-label="maximize"
            >
                <i class="fas fa-external-link-alt" aria-hidden="true" />
            </router-link>
        </div>
    </template>
    <template v-else>
        <div class="flex align-items" :class="{ justifyCenter: isMobileView }">
            <div v-if="testObj.startedEarly && testObj.expectedEndingTime" class="flex align-items marginRight20 fs-14px">
                <i class="fa fa-clock marginRight5" aria-hidden="true" />
                <p>Early Start</p>
            </div>

            <div
                class="timer_Div darkGreen"
                :class="{
                    timerPaused: testObj.status == 'paused',
                    'color-dark-blue': testObj.startedEarly && testObj.expectedEndingTime != null,
                }"
                role="timer"
                aria-live="polite"
                aria-atomic="true"
                tabindex="0"
            >
                <span class="visible-hidden">{{ formattedTime }}</span>

                <div v-if="time.days > 0" :class="{ textAlignCenter: isBelow472px }" aria-hidden="true">
                    <div class="time" :class="{ flex: !isBelow472px }" aria-hidden="true">
                        <template v-if="isBelow472px">
                            <div
                                class="number-div margin0 padding8bottom4"
                                :class="{
                                    'displayInlineBlock ': isBelow472px,
                                }"
                            >
                                {{ time.days }}
                            </div>
                        </template>
                        <template v-else>
                            <div v-for="day in time.days" class="number-div">
                                {{ day }}
                            </div>
                        </template>
                    </div>

                    <label class="width100 textAlignCenter" :class="{ marginTop10: isMobileView }">
                        <span class="visible-hidden">{{ time.days }}</span>
                        {{ time.days > 1 ? 'Days' : 'Day' }}
                    </label>
                </div>

                <div v-if="time.days > 0" :class="{ padding6: isBelow472px, padding10: !isBelow472px }" aria-hidden="true">:</div>

                <div :class="{ textAlignCenter: isBelow472px }" aria-hidden="true">
                    <div class="time" :class="{ flex: !isBelow472px }" aria-hidden="true">
                        <template v-if="isBelow472px">
                            <div
                                class="number-div margin0 padding8bottom4"
                                :class="{
                                    'displayInlineBlock ': isBelow472px,
                                }"
                            >
                                {{ time.hours }}
                            </div>
                        </template>
                        <template v-else>
                            <div class="number-div">
                                {{ time.hours.charAt(0) }}
                            </div>
                            <div class="number-div">
                                {{ time.hours.charAt(1) }}
                            </div>
                        </template>
                    </div>
                    <label class="width100 textAlignCenter" :class="{ marginTop10: isMobileView }">
                        <span class="visible-hidden">{{ time.hours }}</span>
                        {{ time.hours > 1 ? 'Hours' : 'Hour' }}
                    </label>
                </div>

                <div :class="{ padding6: isBelow472px, padding10: !isBelow472px }" aria-hidden="true">:</div>

                <div :class="{ 'textAlignCenter width55px': isBelow472px }" aria-hidden="true">
                    <div class="time" :class="{ flex: !isBelow472px }" aria-hidden="true">
                        <template v-if="isBelow472px">
                            <div
                                class="number-div margin0 padding8bottom4"
                                :class="{
                                    'displayInlineBlock ': isBelow472px,
                                }"
                            >
                                {{ time.minutes }}
                            </div>
                        </template>
                        <template v-else>
                            <div class="number-div">
                                {{ time.minutes.charAt(0) }}
                            </div>
                            <div class="number-div">
                                {{ time.minutes.charAt(1) }}
                            </div>
                        </template>
                    </div>
                    <label class="width100 textAlignCenter" :class="{ marginTop10: isMobileView }">
                        <span class="visible-hidden">{{ time.minutes }}</span>
                        {{ time.minutes > 1 ? 'Minutes' : 'Minute' }}
                    </label>
                </div>

                <div :class="{ padding6: isBelow472px, padding10: !isBelow472px }" aria-hidden="true">:</div>

                <div :class="{ textAlignCenter: isBelow472px }" aria-hidden="true">
                    <div class="time" :class="{ flex: !isBelow472px }" aria-hidden="true">
                        <template v-if="isBelow472px">
                            <div
                                class="number-div margin0 padding8bottom4"
                                :class="{
                                    'displayInlineBlock ': isBelow472px,
                                }"
                            >
                                {{ time.seconds }}
                            </div>
                        </template>
                        <template v-else>
                            <div class="number-div">
                                {{ time.seconds.charAt(0) }}
                            </div>
                            <div class="number-div">
                                {{ time.seconds.charAt(1) }}
                            </div>
                        </template>
                    </div>
                    <label class="width100 textAlignCenter" :class="{ marginTop10: isMobileView }">
                        <span class="visible-hidden">{{ time.seconds }}</span>
                        {{ time.seconds > 1 ? 'Seconds' : 'Second' }}
                    </label>
                </div>
            </div>

            <router-link
                v-if="showWindowLink && !isMobileView"
                v-tooltip="'Show in new window'"
                :to="{
                    name: 'activities.tests.timer',
                    params: { id: testObj.uuid },
                }"
                class="btn btn-default"
                target="_blank"
                aria-label="maximize"
            >
                <i class="fas fa-external-link-alt" aria-hidden="true" />
            </router-link>
        </div>
    </template>
</template>
<script>
export default {
    props: ['testObj', 'options'],
    data() {
        return {
            timer: null,
            time: { days: '00', hours: '00', minutes: '00', seconds: '00' },
            showWindowLink: false,
            runAutoEnd: false,
            formattedTime: '',
        };
    },
    computed: {
        shouldStartTimer() {
            return this.testObj.status == 'ongoing' || this.testObj.expectedEndingTime || this.testObj.status == 'paused';
        },
    },
    watch: {
        'testObj.expectedEndingTime': {
            handler: function () {
                if (this.shouldStartTimer) {
                    this.initTimer();
                } else {
                    this.stopTimer();
                }
            },
        },
        'testObj.status': {
            handler: function () {
                if (this.testObj.status == 'paused') {
                    this.processPausedTimerOnInit();
                } else if (this.shouldStartTimer) {
                    this.initTimer();
                } else {
                    this.stopTimer();
                }
            },
        },
        'testObj.startTime': {
            handler: function () {
                if (this.shouldStartTimer) {
                    this.initTimer();
                } else {
                    this.stopTimer();
                }
            },
        },
        'testObj.endTime': {
            handler: function () {
                if (this.shouldStartTimer) {
                    this.initTimer();
                } else {
                    this.stopTimer();
                }
            },
        },
    },
    created() {
        this.showWindowLink = _.get(this.options, 'showWindowLink', false);
        this.runAutoEnd = _.get(this.options, 'runAutoEnd', false);
    },
    mounted() {
        if (this.testObj.status == 'paused') {
            this.processPausedTimerOnInit();
        } else if (this.shouldStartTimer) {
            this.initTimer();
        } else {
        }
    },
    methods: {
        stopTimer() {
            if (this.timer) {
                clearInterval(this.timer);
            }
        },
        processPausedTimerOnInit() {
            if (this.testObj.status == 'paused') {
                this.stopTimer();
                var startTime = this.convertToReadableDate(_.get(this.testObj, 'startTime', '')).dateObj;
                var endTime = this.convertToReadableDate(_.get(this.testObj, 'endTime', '')).dateObj;
                var totalDistance = moment.duration(endTime.diff(startTime));
                var timePaused = this.convertToReadableDate(_.get(this.testObj, 'timePaused', '')).dateObj;
                var distance = moment.duration(endTime.diff(timePaused));
                var daysFromStart = Math.floor(distance.asDays());
                if (distance > 0) {
                    const daysString = daysFromStart.toString();
                    const sliceDayLength = Math.max(2, daysString.length);
                    this.time.days = ('0' + daysFromStart).slice(-sliceDayLength);

                    this.time.days = ('0' + distance.days()).slice(-2);
                    this.time.hours = ('0' + distance.hours()).slice(-2);
                    this.time.minutes = ('0' + distance.minutes()).slice(-2);
                    this.time.seconds = ('0' + distance.seconds()).slice(-2);
                } else {
                    this.time.days = '00';
                    this.time.hours = '00';
                    this.time.minutes = '00';
                    this.time.seconds = '00';
                }
                return;
            }
        },
        initTimer() {
            var that = this;
            this.isShown = true;
            if (!(_.get(this.testObj, 'startTime') && _.get(this.testObj, 'endTime')) && !_.get(this.testObj, 'expectedEndingTime')) {
                return;
            }
            //sync or async uses same time.
            var startTime = this.convertToReadableDate(_.get(this.testObj, 'startTime', '')).dateObj;
            var endTime = this.convertToReadableDate(_.get(this.testObj, 'endTime') || _.get(this.testObj, 'expectedEndingTime')).dateObj;
            var totalDistance = moment.duration(endTime.diff(startTime));
            this.stopTimer();
            this.timer = setInterval(function () {
                var now = moment();
                var distance = moment.duration(endTime.diff(now));
                var daysFromStart = Math.floor(distance.asDays());
                if (distance > 0) {
                    const daysString = daysFromStart.toString();
                    const sliceDayLength = Math.max(2, daysString.length);
                    that.time.days = ('0' + daysFromStart).slice(-sliceDayLength);
                    that.time.hours = ('0' + distance.hours()).slice(-2);
                    that.time.minutes = ('0' + distance.minutes()).slice(-2);
                    that.time.seconds = ('0' + distance.seconds()).slice(-2);
                } else {
                    if (that.testObj.settings.type == 'synchronous' && that.runAutoEnd) {
                        let url = `tests/${that.testObj.uuid}`;
                        if (_.get(that.testObj, 'expectedEndingTime')) {
                            url += '/early-start/end';
                        } else {
                            url += '/auto-end';
                        }
                        axios
                            .post(url)
                            .then(function (response) {})
                            .catch(function (errors) {});
                    }
                    that.time.days = '00';
                    that.time.hours = '00';
                    that.time.minutes = '00';
                    that.time.seconds = '00';
                    that.stopTimer();
                }

                const parts = [];

                if (that.time.days !== '00') {
                    parts.push(`${parseInt(that.time.days)} days`);
                }
                if (that.time.hours !== '00') {
                    parts.push(`${parseInt(that.time.hours)} hours`);
                }
                if (that.time.minutes !== '00') {
                    parts.push(`${parseInt(that.time.minutes)} minutes`);
                }

                if (distance._milliseconds > 60000) {
                    if (parts.length > 1) {
                        const lastPart = parts.pop();
                        that.formattedTime = `Time Left with ${parts.join(', ')} and ${lastPart}`;
                    } else {
                        that.formattedTime = `Time Left with ${parts[0]}`;
                    }
                } else if (distance._milliseconds > 59000 && distance._milliseconds < 60000) {
                    that.formattedTime = `Time left with ${that.time.seconds} seconds`;
                } else if (distance._milliseconds > 10000 && distance._milliseconds < 10999) {
                    that.formattedTime = `Time Left with 10 seconds`;
                }
            }, 1000);
        },
    },
};
</script>
<style scoped>
.bigAlert {
    color: #ca3333;
    font-size: 2.667rem;
    font-weight: bold;
    line-height: 1;
}

.fa-external-link-alt {
    font-size: 1rem;
}

.time .number-div {
    background: #fff;
    padding: 5px 10px 0px;
    border-radius: 3px;
    box-shadow: 0 2px 4px 0 rgba(128, 128, 128, 0.5);
}

.time .number-div:not(:first-child) {
    margin-left: 5px;
}

.colon {
    color: #717171;
}

.timer_Div {
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin-bottom: 0;
    font-weight: bold;
    line-height: 1;
}

@media (min-width: 992px) {
    .timer_Div {
        font-size: 2.111rem;
        font-weight: bold;
        line-height: 1;
    }

    .colon {
        padding: 0 10px;
    }

    .timer-wrapper .timer_Div {
        font-size: 5.556rem;
    }

    .timer-wrapper .time .number-div {
        padding: 10px 10px 0;
    }
}

@media (max-width: 991px) {
    .timer_Div {
        font-size: 1.667rem;
        font-weight: bold;
        line-height: 1;
    }

    .colon {
        padding: 0 5px;
    }

    .timer-wrapper .timer_Div {
        font-size: 1.667rem;
    }
}

.timeText {
    color: #222;
    font-size: 0.88rem;
    font-weight: bold;
    text-align: center;
    margin-top: 5px;
}
.timerPaused {
    opacity: 0.2;
}
</style>
